// extracted by mini-css-extract-plugin
export default {"buttonToAnswerQuestion":"_1-z","disabled":"a2-z","seeAllAnswers":"b2-z"};